import React, { Component } from 'react'
import ElementsDataService from '../../api/entitiesDataServices/ElementsDataService.js'
import { Link } from 'react-router-dom'
import AuthenticationService from '../general/AuthenticationService.js'
import UnauthorizedComponent from '../general/UnauthorizedComponent.jsx'

const T = {
    bg: '#f1f5f9', card: '#ffffff', border: '#e8edf5',
    blue: '#3b82f6', blueD: '#2563eb', navy: '#0f172a',
    txt: '#1e293b', txt2: '#64748b', muted: '#94a3b8',
    green: '#16a34a', greenBg: '#f0fdf4', greenBdr: '#bbf7d0',
    red: '#dc2626', redBg: '#fef2f2', redBdr: '#fecaca',
    warn: '#f59e0b', warnBg: '#fffbeb', warnBdr: '#fde68a',
    r: 16, rsm: 10, shadow: '0 1px 3px rgba(15,23,42,.06)',
    font: "'Inter',-apple-system,BlinkMacSystemFont,sans-serif"
}

// Collapsible section component
function Section({ title, icon, count, children, defaultOpen = false }) {
    const [open, setOpen] = React.useState(defaultOpen)
    return (
        <div style={{ border: `1px solid ${T.border}`, borderRadius: T.r, overflow: 'hidden', marginBottom: 12 }}>
            <button
                onClick={() => setOpen(!open)}
                style={{
                    width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    padding: '14px 20px', background: open ? '#f8fafc' : T.card,
                    border: 'none', cursor: 'pointer', fontFamily: T.font,
                    borderBottom: open ? `1px solid ${T.border}` : 'none',
                    transition: 'background 0.15s'
                }}
            >
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <span style={{ fontSize: '1rem' }}>{icon}</span>
                    <span style={{ fontSize: '0.88rem', fontWeight: 700, color: T.txt }}>{title}</span>
                    {count !== undefined && (
                        <span style={{ fontSize: '0.7rem', background: '#eff6ff', color: T.blue, border: `1px solid #bfdbfe`, borderRadius: 20, padding: '2px 8px', fontWeight: 600 }}>
                            {count}
                        </span>
                    )}
                </div>
                <span style={{ color: T.muted, fontSize: '0.8rem', transform: open ? 'rotate(180deg)' : 'rotate(0)', transition: 'transform 0.2s', display: 'inline-block' }}>▼</span>
            </button>
            {open && <div style={{ padding: '16px 20px', background: T.card }}>{children}</div>}
        </div>
    )
}

// Info row component
function InfoRow({ label, children, mono = false }) {
    return (
        <div style={{ display: 'grid', gridTemplateColumns: '220px 1fr', gap: 16, padding: '11px 0', borderBottom: `1px solid ${T.border}`, alignItems: 'start' }}>
            <span style={{ fontSize: '0.78rem', fontWeight: 600, color: T.txt2, letterSpacing: '0.3px', paddingTop: 1 }}>{label}</span>
            <span style={{ fontSize: '0.85rem', color: T.txt, fontFamily: mono ? 'monospace' : T.font, wordBreak: 'break-word' }}>{children || <span style={{ color: T.muted }}>—</span>}</span>
        </div>
    )
}

// Status badge
function Badge({ text, type = 'default' }) {
    const colors = {
        default: { bg: '#f1f5f9', color: T.txt2, border: T.border },
        green:   { bg: T.greenBg, color: T.green, border: T.greenBdr },
        red:     { bg: T.redBg,   color: T.red,   border: T.redBdr },
        warn:    { bg: T.warnBg,  color: T.warn,  border: T.warnBdr },
        blue:    { bg: '#eff6ff', color: T.blue,  border: '#bfdbfe' },
    }
    const c = colors[type] || colors.default
    if (!text) return <span style={{ color: T.muted }}>—</span>
    return (
        <span style={{ fontSize: '0.75rem', fontWeight: 700, background: c.bg, color: c.color, border: `1px solid ${c.border}`, borderRadius: 20, padding: '3px 10px', display: 'inline-block', letterSpacing: '0.3px' }}>
            {text}
        </span>
    )
}

function getStatusType(status) {
    if (!status) return 'default'
    const s = status.toUpperCase()
    if (s.includes('ACTIV')) return 'green'
    if (s.includes('SUSPEND') || s.includes('LIQUID') || s.includes('VEND')) return 'red'
    if (s.includes('PROCESO') || s.includes('REVISION')) return 'warn'
    return 'default'
}

class SociedadReporteComponent extends Component {
    constructor(props) {
        super(props)
        this.state = {
            id: this.props.match.params.id,
            correo: '', password: '', generacion: '',
            domicilios: [], opinionCumplimiento: '', pendientes: '',
            razonSocial: '', revisionFiscal: '', status: '',
            statusContabilidad: '', responsableContabilidad: '',
            auxiliarContable: '', tipo: '', situacion: '', rfc: '',
            clientes: [], documentos: [], softDelete: '',
            datosConstitucion: '', objetoSocial: '', clausulaExtranjeria: '',
            capitalSocialFijo: '', capitalSocialVariable: '',
            valorNominal: '', distribucionCapital: '',
            allPersonasFisicas: [], allDomicilios: [],
            vigenciaFiel: '', telefono: '', telefonoDesignadoCliente: '',
            buzonTributarioStatus: '', historialSociedadDomicilios: [],
            fechaSuspension: '', fechaEntrega: '',
            entidadesRolesComentarios: [],
            loading: true,
            unauthorized: false,
        }
    }

    componentDidMount() {
        if (!AuthenticationService.haveAuthorization("READ_SOCIEDADES")) {
            this.setState({ unauthorized: true })
            return
        }
        const { match: { params } } = this.props
        if (Number(params.id) === -1) { this.setState({ loading: false }); return }
        ElementsDataService.retrieveElement("sociedades", this.state.id)
            .then(response => {
                const d = response.data
                this.setState({
                    correo: d.correo, password: d.password, generacion: d.generacion,
                    domicilios: d.domicilios || [], opinionCumplimiento: d.opinionCumplimiento,
                    pendientes: d.pendientes, razonSocial: d.razonSocial,
                    revisionFiscal: d.revisionFiscal, status: d.status,
                    statusContabilidad: d.statusContabilidad,
                    responsableContabilidad: d.responsableContabilidad,
                    auxiliarContable: d.auxiliarContable, tipo: d.tipo,
                    situacion: d.situacion, rfc: d.rfc,
                    clientes: d.clientes || [], documentos: d.documentos || [],
                    entidadesRolesComentarios: d.entidadesRolesComentarios || [],
                    datosConstitucion: d.datosConstitucion, objetoSocial: d.objetoSocial,
                    clausulaExtranjeria: d.clausulaExtranjeria,
                    capitalSocialFijo: d.capitalSocialFijo,
                    capitalSocialVariable: d.capitalSocialVariable,
                    valorNominal: d.valorNominal, distribucionCapital: d.distribucionCapital,
                    vigenciaFiel: d.vigenciaFiel, telefono: d.telefono,
                    telefonoDesignadoCliente: d.telefonoDesignadoCliente,
                    buzonTributarioStatus: d.buzonTributarioStatus,
                    historialSociedadDomicilios: d.historialSociedadDomicilios || [],
                    fechaSuspension: d.fechaSuspension, fechaEntrega: d.fechaEntrega,
                    loading: false,
                })
            })
            .catch(() => this.setState({ loading: false }))
    }

    render() {
        const {
            id, correo, password, generacion, opinionCumplimiento, pendientes,
            razonSocial, revisionFiscal, status, tipo, situacion, rfc,
            clientes, domicilios, documentos, entidadesRolesComentarios,
            datosConstitucion, objetoSocial, clausulaExtranjeria,
            capitalSocialFijo, capitalSocialVariable, valorNominal, distribucionCapital,
            vigenciaFiel, statusContabilidad, responsableContabilidad, auxiliarContable,
            telefono, telefonoDesignadoCliente, buzonTributarioStatus,
            historialSociedadDomicilios, fechaSuspension, fechaEntrega, loading,
        } = this.state

        // Sort domicilios by fechaInicio desc
        const listaDomiciliosOrdenados = [...domicilios].sort((a, b) => {
            let fa = 0, fb = 0
            historialSociedadDomicilios.filter(h => h.domicilioId == a.id).forEach(h => {
                const p = Date.parse(h.fechaInicio); if (!isNaN(p)) fa = p
            })
            historialSociedadDomicilios.filter(h => h.domicilioId == b.id).forEach(h => {
                const p = Date.parse(h.fechaInicio); if (!isNaN(p)) fb = p
            })
            return fb - fa
        })

        const domicilioLabel = (d) =>
            `${d.calle} #${d.numeroExt}${d.numeroInterior ? ' Int. ' + d.numeroInterior : ''}, ${d.colonia}, ${d.municipio}, ${d.estado}`

        // Documentos that affect socios
        const SOCIOS_TIPOS = ['Constitutiva', 'Compra venta de acciones/partes sociales',
            'Nombramiento Administrador/Consejo de Administración', 'Admisión/Renuncia de Asociados']
        const docsConSocios = documentos.filter(d => d.asuntos && SOCIOS_TIPOS.some(t => d.asuntos.includes(t)))
        const docCIF = documentos.find(d => d.tipoDocumento === 'CIF')

        if (loading) {
            return (
                <div style={{ minHeight: '100vh', background: T.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: T.font }}>
                    <div style={{ textAlign: 'center', color: T.muted }}>
                        <div style={{ fontSize: '2rem', marginBottom: 12 }}>⏳</div>
                        <p style={{ margin: 0, fontSize: '0.9rem' }}>Cargando reporte...</p>
                    </div>
                </div>
            )
        }

        return (
            <div style={{ minHeight: '100vh', background: T.bg, fontFamily: T.font }}>
                {this.state.unauthorized && <UnauthorizedComponent history={this.props.history} />}
                <style>{`
                    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
                    * { box-sizing: border-box; }
                    .soc-link { color: ${T.blue}; text-decoration: none; font-weight: 600; }
                    .soc-link:hover { text-decoration: underline; }
                    .action-btn {
                        display: inline-flex; align-items: center; gap: 7px;
                        padding: 9px 18px; border-radius: ${T.rsm}px;
                        font-size: 0.82rem; font-weight: 600; cursor: pointer;
                        border: none; font-family: ${T.font}; transition: all 0.2s;
                    }
                    .btn-edit { background: ${T.navy}; color: white; }
                    .btn-edit:hover { background: #1e293b; transform: translateY(-1px); }
                    .btn-new { background: ${T.blue}; color: white; box-shadow: 0 4px 12px rgba(59,130,246,0.3); }
                    .btn-new:hover { background: ${T.blueD}; transform: translateY(-1px); }
                    .btn-back { background: white; color: ${T.txt2}; border: 1px solid ${T.border} !important; }
                    .btn-back:hover { border-color: ${T.blue} !important; color: ${T.blue}; }
                    .btn-dl { background: ${T.greenBg}; color: ${T.green}; border: 1px solid ${T.greenBdr} !important; }
                    .btn-dl:hover { background: ${T.green}; color: white; }
                    .doc-row { display: flex; align-items: flex-start; gap: 12px; padding: 12px 0; border-bottom: 1px solid ${T.border}; }
                    .doc-row:last-child { border-bottom: none; padding-bottom: 0; }
                    .doc-acc { border: 1px solid ${T.border}; border-radius: ${T.rsm}px; overflow: hidden; margin-bottom: 8px; }
                    .doc-acc-header { display: flex; align-items: center; justify-content: space-between; padding: 12px 16px; cursor: pointer; background: #f8fafc; border: none; width: 100%; font-family: ${T.font}; transition: background 0.15s; }
                    .doc-acc-header:hover { background: #f1f5f9; }
                    .doc-acc-body { padding: 14px 16px; background: white; border-top: 1px solid ${T.border}; }
                    .roles-table { width: 100%; font-size: 0.8rem; border-collapse: collapse; }
                    .roles-table td { padding: 5px 8px; border-bottom: 1px solid ${T.border}; }
                    .roles-table tr:last-child td { border-bottom: none; }
                `}</style>

                <div style={{ maxWidth: 960, margin: '0 auto', padding: '28px 24px' }}>

                    {/* Header */}
                    <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 24, flexWrap: 'wrap', gap: 12 }}>
                        <div>
                            <button className="action-btn btn-back" onClick={() => this.props.history.goBack()} style={{ marginBottom: 12 }}>
                                ‹ Volver
                            </button>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 4 }}>
                                <span style={{ fontSize: '0.7rem', fontWeight: 700, background: '#eff6ff', color: T.blue, border: '1px solid #bfdbfe', borderRadius: 20, padding: '3px 10px', letterSpacing: '1px', textTransform: 'uppercase' }}>
                                    Reporte Legal
                                </span>
                                <Badge text={status} type={getStatusType(status)} />
                            </div>
                            <h1 style={{ margin: 0, fontSize: '1.5rem', fontWeight: 800, color: T.navy, lineHeight: 1.2 }}>{razonSocial || '—'}</h1>
                            {rfc && (
                                <Link to={`/sociedades/reportesContables/${rfc}`} className="soc-link" style={{ fontSize: '0.9rem', fontFamily: 'monospace', marginTop: 4, display: 'inline-block' }}>
                                    {rfc}
                                </Link>
                            )}
                        </div>
                        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                            <button className="action-btn btn-edit" onClick={() => this.props.history.push(`/sociedades/${id}`)}>
                                ✏️ Editar
                            </button>
                            <button className="action-btn btn-new" onClick={() => this.props.history.push(`/sociedades/-1`)}>
                                + Nueva
                            </button>
                        </div>
                    </div>

                    {/* Main info card */}
                    <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: T.r, padding: '20px 24px', marginBottom: 16, boxShadow: T.shadow }}>
                        <h2 style={{ margin: '0 0 16px', fontSize: '0.75rem', fontWeight: 700, color: T.muted, letterSpacing: '1.5px', textTransform: 'uppercase' }}>Datos Generales</h2>

                        <InfoRow label="Razón Social / Denominación">{razonSocial}</InfoRow>
                        <InfoRow label="RFC">
                            {rfc ? <Link to={`/sociedades/reportesContables/${rfc}`} className="soc-link" style={{ fontFamily: 'monospace' }}>{rfc}</Link> : '—'}
                        </InfoRow>
                        <InfoRow label="Responsable Contabilidad">{responsableContabilidad}</InfoRow>
                        <InfoRow label="Auxiliar Contable">{auxiliarContable}</InfoRow>
                        <InfoRow label="Teléfono">{telefono}</InfoRow>
                        <InfoRow label="Teléfono Designado por el Cliente">{telefonoDesignadoCliente}</InfoRow>

                        {/* Domicilios */}
                        <div style={{ display: 'grid', gridTemplateColumns: '220px 1fr', gap: 16, padding: '11px 0', borderBottom: `1px solid ${T.border}` }}>
                            <span style={{ fontSize: '0.78rem', fontWeight: 600, color: T.txt2, paddingTop: 1 }}>Domicilios ({domicilios.length})</span>
                            <div>
                                {listaDomiciliosOrdenados.length === 0 ? (
                                    <span style={{ color: T.muted, fontSize: '0.85rem' }}>—</span>
                                ) : (
                                    <>
                                        {/* Current domicilio */}
                                        {listaDomiciliosOrdenados.slice(0, 1).map(d => (
                                            <div key={d.id} style={{ marginBottom: listaDomiciliosOrdenados.length > 1 ? 8 : 0 }}>
                                                <Link to={`/domicilios/reportes/${d.id}`} className="soc-link" style={{ fontSize: '0.85rem' }}>
                                                    {domicilioLabel(d)}
                                                </Link>
                                                {historialSociedadDomicilios.filter(h => h.domicilioId == d.id && h.fechaInicio).map((h, i) => (
                                                    <div key={i} style={{ fontSize: '0.78rem', color: T.txt2, marginTop: 4, lineHeight: 1.7 }}>
                                                        <span><b>Desde:</b> {h.fechaInicio} {h.fechaFin ? <><b> Hasta: </b>{h.fechaFin}</> : <b style={{ color: T.green }}> *Actual</b>}</span><br />
                                                        <span><b>Estatus:</b> {d.estatus}</span>
                                                        {d.telefono && <><br /><span><b>Teléfono:</b> {d.telefono}</span></>}
                                                    </div>
                                                ))}
                                            </div>
                                        ))}
                                        {/* Previous domicilios collapsible */}
                                        {listaDomiciliosOrdenados.length > 1 && (
                                            <details style={{ marginTop: 4 }}>
                                                <summary style={{ fontSize: '0.78rem', color: T.blue, cursor: 'pointer', fontWeight: 600, listStyle: 'none', display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                                                    ▼ Ver {listaDomiciliosOrdenados.length - 1} domicilio(s) anterior(es)
                                                </summary>
                                                <div style={{ marginTop: 8, paddingLeft: 12, borderLeft: `2px solid ${T.border}` }}>
                                                    {listaDomiciliosOrdenados.slice(1).map(d => (
                                                        <div key={d.id} style={{ marginBottom: 12 }}>
                                                            <Link to={`/domicilios/reportes/${d.id}`} className="soc-link" style={{ fontSize: '0.83rem' }}>
                                                                {domicilioLabel(d)}
                                                            </Link>
                                                            {historialSociedadDomicilios.filter(h => h.domicilioId == d.id && h.fechaInicio).map((h, i) => (
                                                                <div key={i} style={{ fontSize: '0.77rem', color: T.txt2, marginTop: 3, lineHeight: 1.7 }}>
                                                                    <span><b>Desde:</b> {h.fechaInicio} {h.fechaFin ? <><b> Hasta: </b>{h.fechaFin}</> : <b style={{ color: T.green }}> *Actual</b>}</span><br />
                                                                    <span><b>Estatus:</b> {d.estatus}</span>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    ))}
                                                </div>
                                            </details>
                                        )}
                                    </>
                                )}
                            </div>
                        </div>

                        {/* Proyectos */}
                        <div style={{ display: 'grid', gridTemplateColumns: '220px 1fr', gap: 16, padding: '11px 0', borderBottom: `1px solid ${T.border}` }}>
                            <span style={{ fontSize: '0.78rem', fontWeight: 600, color: T.txt2, paddingTop: 1 }}>Proyectos</span>
                            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 8 }}>
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                                    {clientes.length ? clientes.map(c => (
                                        <Link key={c.id} to={`/clientes/reportes/${c.id}`} style={{ fontSize: '0.8rem', background: '#eff6ff', color: T.blue, border: '1px solid #bfdbfe', borderRadius: 20, padding: '3px 12px', textDecoration: 'none', fontWeight: 600 }}>
                                            {c.nombreCliente}
                                        </Link>
                                    )) : <span style={{ color: T.muted, fontSize: '0.85rem' }}>—</span>}
                                </div>
                                {fechaEntrega && (
                                    <span style={{ fontSize: '0.78rem', color: T.txt2, marginLeft: 8 }}>
                                        📅 Entrega: <b>{fechaEntrega}</b>
                                    </span>
                                )}
                            </div>
                        </div>

                        <InfoRow label="Estatus Buzón Tributario"><Badge text={buzonTributarioStatus} type={getStatusType(buzonTributarioStatus)} /></InfoRow>
                        <InfoRow label="Correo Electrónico">{correo}</InfoRow>
                        <InfoRow label="Contraseña de Correo">{password}</InfoRow>
                        <InfoRow label="Vigencia FIEL">{vigenciaFiel}</InfoRow>
                        <InfoRow label="Generación">{generacion}</InfoRow>
                        <InfoRow label="Estatus Legal"><Badge text={status} type={getStatusType(status)} /></InfoRow>
                        <InfoRow label="Estatus Contable">
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <Badge text={statusContabilidad} type={getStatusType(statusContabilidad)} />
                                {statusContabilidad === 'SUSPENDIDA' && fechaSuspension && (
                                    <span style={{ fontSize: '0.78rem', color: T.txt2 }}>desde {fechaSuspension}</span>
                                )}
                            </div>
                        </InfoRow>
                        <InfoRow label="Tipo">{tipo}</InfoRow>
                        <InfoRow label="Revisión Fiscal">{revisionFiscal}</InfoRow>
                        <InfoRow label="Opinión Cumplimiento">{opinionCumplimiento}</InfoRow>
                        <InfoRow label="Situación">{situacion}</InfoRow>
                        <InfoRow label="Pendientes"><span style={{ whiteSpace: 'pre-wrap' }}>{pendientes}</span></InfoRow>
                    </div>

                    {/* Constitución y Capital */}
                    <Section title="Constitución y Capital Social" icon="🏛️" defaultOpen={false}>
                        <InfoRow label="Datos Constitución"><span style={{ whiteSpace: 'pre-wrap' }}>{datosConstitucion}</span></InfoRow>
                        <InfoRow label="Objeto Social"><span style={{ whiteSpace: 'pre-wrap' }}>{objetoSocial}</span></InfoRow>
                        <InfoRow label="Cláusula Extranjería">{clausulaExtranjeria}</InfoRow>
                        <InfoRow label="Capital Social Fijo">{capitalSocialFijo}</InfoRow>
                        <InfoRow label="Capital Social Variable">{capitalSocialVariable}</InfoRow>
                        <InfoRow label="Valor Nominal">{valorNominal}</InfoRow>
                        <InfoRow label="Distribución Capital">{distribucionCapital}</InfoRow>
                    </Section>

                    {/* CIF */}
                    {docCIF && (
                        <div style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: T.r, padding: '16px 20px', marginBottom: 16, display: 'flex', alignItems: 'center', justifyContent: 'space-between', boxShadow: T.shadow }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                <span style={{ fontSize: '1.2rem' }}>📋</span>
                                <div>
                                    <span style={{ fontSize: '0.7rem', fontWeight: 700, color: T.muted, letterSpacing: '1px', textTransform: 'uppercase', display: 'block' }}>CIF</span>
                                    <Link to={`/documentos/reportes/${docCIF.id}`} className="soc-link" style={{ fontSize: '0.85rem' }}>
                                        {docCIF.asuntos || docCIF.tipoDocumento}
                                    </Link>
                                    {docCIF.fecha && <span style={{ fontSize: '0.78rem', color: T.txt2, marginLeft: 8 }}>{docCIF.fecha}</span>}
                                </div>
                            </div>
                            {docCIF.documentFileUrl && (
                                <button className="action-btn btn-dl" onClick={() =>
                                    ElementsDataService.downloadS3File(`?fileName=${docCIF.documentFileUrl}`, `${rfc}_CIF.pdf`)
                                }>
                                    ⬇ Descargar
                                </button>
                            )}
                        </div>
                    )}

                    {/* Socios */}
                    {docsConSocios.length > 0 && (
                        <Section title="Socios / Administración" icon="👥" count={docsConSocios.length} defaultOpen={true}>
                            {/* Current - first doc */}
                            {docsConSocios.slice(0, 1).map(doc => (
                                <div key={doc.id} style={{ marginBottom: 12 }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
                                        <span style={{ fontSize: '0.7rem', background: T.greenBg, color: T.green, border: `1px solid ${T.greenBdr}`, borderRadius: 20, padding: '2px 8px', fontWeight: 700 }}>ACTUAL</span>
                                        <Link to={`/documentos/reportes/${doc.id}`} className="soc-link" style={{ fontSize: '0.85rem' }}>
                                            {doc.asuntos || doc.tipoDocumento}
                                        </Link>
                                        <span style={{ fontSize: '0.78rem', color: T.txt2 }}>{doc.fecha}</span>
                                    </div>
                                    <table className="roles-table">
                                        <tbody>
                                            {entidadesRolesComentarios.filter(r => r.documentoId == doc.id).map((r, i) => (
                                                <tr key={i}>
                                                    <td style={{ color: T.txt2, fontSize: '0.78rem', width: 200 }}>{r.rol}</td>
                                                    <td>
                                                        <Link to={r.tipo === 'personaFisica' ? `/personas-fisicas/reportes/${r.entidadId}` : `/sociedades/reportes/${r.entidadId}`} className="soc-link" style={{ fontSize: '0.83rem' }}>
                                                            {r.razonSocial}
                                                        </Link>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            ))}
                            {/* Previous docs */}
                            {docsConSocios.length > 1 && (
                                <details style={{ marginTop: 8 }}>
                                    <summary style={{ fontSize: '0.78rem', color: T.blue, cursor: 'pointer', fontWeight: 600, listStyle: 'none', display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                                        ▼ Ver {docsConSocios.length - 1} documento(s) anterior(es)
                                    </summary>
                                    <div style={{ marginTop: 10, paddingLeft: 12, borderLeft: `2px solid ${T.border}` }}>
                                        {docsConSocios.slice(1).map(doc => (
                                            <div key={doc.id} style={{ marginBottom: 14 }}>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                                                    <Link to={`/documentos/reportes/${doc.id}`} className="soc-link" style={{ fontSize: '0.83rem' }}>
                                                        {doc.asuntos || doc.tipoDocumento}
                                                    </Link>
                                                    <span style={{ fontSize: '0.76rem', color: T.txt2 }}>{doc.fecha}</span>
                                                </div>
                                                <table className="roles-table">
                                                    <tbody>
                                                        {entidadesRolesComentarios.filter(r => r.documentoId == doc.id).map((r, i) => (
                                                            <tr key={i}>
                                                                <td style={{ color: T.txt2, fontSize: '0.78rem', width: 200 }}>{r.rol}</td>
                                                                <td>
                                                                    <Link to={r.tipo === 'personaFisica' ? `/personas-fisicas/reportes/${r.entidadId}` : `/sociedades/reportes/${r.entidadId}`} className="soc-link" style={{ fontSize: '0.81rem' }}>
                                                                        {r.razonSocial}
                                                                    </Link>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        ))}
                                    </div>
                                </details>
                            )}
                        </Section>
                    )}

                    {/* Documentos */}
                    <Section title="Documentos" icon="📄" count={documentos.length} defaultOpen={true}>
                        {documentos.length === 0 ? (
                            <p style={{ color: T.muted, fontSize: '0.85rem', margin: 0 }}>Sin documentos registrados.</p>
                        ) : (
                            <>
                                {/* Header */}
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 120px 80px', gap: 12, padding: '8px 16px', background: '#f8fafc', borderRadius: T.rsm, marginBottom: 8 }}>
                                    <span style={{ fontSize: '0.7rem', fontWeight: 700, color: T.muted, letterSpacing: '1px', textTransform: 'uppercase' }}>Asunto</span>
                                    <span style={{ fontSize: '0.7rem', fontWeight: 700, color: T.muted, letterSpacing: '1px', textTransform: 'uppercase' }}>Fecha</span>
                                    <span style={{ fontSize: '0.7rem', fontWeight: 700, color: T.muted, letterSpacing: '1px', textTransform: 'uppercase' }}>Archivo</span>
                                </div>
                                {documentos.map(doc => (
                                    <DocAccordion
                                        key={doc.id}
                                        doc={doc}
                                        razonSocial={razonSocial}
                                        rfc={rfc}
                                        roles={entidadesRolesComentarios}
                                    />
                                ))}
                            </>
                        )}
                    </Section>

                </div>
            </div>
        )
    }
}

// Separate doc accordion to use local state
class DocAccordion extends Component {
    constructor(props) {
        super(props)
        this.state = { open: false }
    }
    render() {
        const { doc, razonSocial, rfc, roles } = this.props
        const { open } = this.state
        const docRoles = roles.filter(r => r.documentoId == doc.id)
        const hasDetails = docRoles.length > 0 || doc.resumen

        return (
            <div className="doc-acc">
                <button className="doc-acc-header" onClick={() => this.setState({ open: !open })}>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 120px 80px', gap: 12, width: '100%', alignItems: 'center' }}>
                        <Link
                            to={`/documentos/reportes/${doc.id}`}
                            onClick={e => e.stopPropagation()}
                            style={{ color: T.blue, textDecoration: 'none', fontWeight: 600, fontSize: '0.85rem', textAlign: 'left' }}
                        >
                            {doc.asuntos || doc.tipoDocumento}
                        </Link>
                        <span style={{ fontSize: '0.82rem', color: T.txt2 }}>{doc.fecha}</span>
                        <div onClick={e => e.stopPropagation()}>
                            {doc.documentFileUrl ? (
                                <button
                                    style={{ background: T.greenBg, color: T.green, border: `1px solid ${T.greenBdr}`, borderRadius: 7, padding: '4px 10px', cursor: 'pointer', fontSize: '0.75rem', fontFamily: T.font, fontWeight: 600 }}
                                    onClick={() => ElementsDataService.downloadS3File(`?fileName=${doc.documentFileUrl}`, `${razonSocial}_${rfc}_${(doc.asuntos || '').replace(',', '_')}.pdf`)}
                                >
                                    ⬇
                                </button>
                            ) : (
                                <span style={{ fontSize: '0.75rem', color: T.muted }}>—</span>
                            )}
                        </div>
                    </div>
                    {hasDetails && (
                        <span style={{ color: T.muted, fontSize: '0.75rem', marginLeft: 12, transform: open ? 'rotate(180deg)' : 'rotate(0)', transition: 'transform 0.2s', display: 'inline-block', flexShrink: 0 }}>▼</span>
                    )}
                </button>
                {open && hasDetails && (
                    <div className="doc-acc-body">
                        {docRoles.length > 0 && (
                            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.8rem', marginBottom: doc.resumen ? 12 : 0 }}>
                                <tbody>
                                    {docRoles.map((r, i) => (
                                        <tr key={i}>
                                            <td style={{ padding: '5px 8px', color: T.txt2, width: 200, borderBottom: `1px solid ${T.border}` }}>{r.rol}</td>
                                            <td style={{ padding: '5px 8px', borderBottom: `1px solid ${T.border}` }}>
                                                <Link
                                                    to={r.tipo === 'personaFisica' ? `/personas-fisicas/reportes/${r.entidadId}` : `/sociedades/reportes/${r.entidadId}`}
                                                    style={{ color: T.blue, textDecoration: 'none', fontWeight: 600 }}
                                                >
                                                    {r.razonSocial}
                                                </Link>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        )}
                        {doc.resumen && (
                            <p style={{ margin: 0, fontSize: '0.83rem', color: T.txt, whiteSpace: 'pre-wrap', lineHeight: 1.6 }}>{doc.resumen}</p>
                        )}
                    </div>
                )}
            </div>
        )
    }
}

export default SociedadReporteComponent
